module.exports = __webpack_public_path__ + "img/identification-back.a79879e5.png";